// Cliente Supabase para la AUTENTICACIÓN del coach web app (magic link).
// Los coaches inician sesión con Supabase Auth; el access_token de la sesión se
// reenvía al proxy (/api/supabase-proxy), que lo verifica y resuelve el coach por
// email. Los DATOS siguen yendo por el proxy (service-role) — este cliente se usa
// SOLO para auth (signInWithOtp / getSession / signOut / onAuthStateChange).
//
// La anon key es pública por diseño (necesaria para Supabase Auth); los datos
// están protegidos por RLS + el proxy service-role.
import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_APIKEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // procesa el hash del magic link al volver a la app
  },
});
